import React, { useState, useEffect, createContext, useContext } from "react";
import { requestsClient } from "../utils/RequestsClients";
import { TokenContext } from "./TokenContext";

export const PlatformContext = createContext({
	settings: null,
	getSettings: () => {},
	setSettings: () => {},
});

export const PlatformProvider = ({ children }) => {
	const { pathId, appId } = useContext(TokenContext);
	const [settings, setSettings] = useState(null);

	const getSettings = async () => {
		try {
			const res = await requestsClient.get(
				"platformSettings",
				{
					params: { appId },
				},
				undefined,
				pathId
			);
			setSettings(res.data.settings);
		} catch (error) {
			console.error("Error cargando platform settings:", error);
		}
	};

	useEffect(() => {
		if (pathId && appId) {
			getSettings();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [pathId, appId]);

	return (
		<PlatformContext.Provider value={{ settings, getSettings, setSettings }}>
			{children}
		</PlatformContext.Provider>
	);
};
